export default __webpack_public_path__ + "static/media/topomap_absolute_norm.ae61be19.webp";